module.exports = __webpack_public_path__ + "img/credenciales-google.8a7a08aa.svg";